<template>
  <table class="info-table table table-sm">
    <tr>
      <th class="border-top-0">{{$t('Attribute')}}</th>
      <th class="border-top-0">{{$t('Old')}}</th>
      <th class="border-top-0">{{$t('New')}}</th>
    </tr>
    <tr>
      <td>{{$t('Commissions')}}</td>
      <td v-html="oldData()"></td>
      <td v-html="newData()"></td>
    </tr>
  </table>
</template>

<script>
  export default {
    name: "ActivityCommissionsTable",
    props: {
      activity: {
        type: Object,
        required: true
      }
    },
    methods: {
      oldData() {
        if (!this.activity.old_data) {
          return 'N/A';
        }
        return this.getCommissionsData(this.activity.old_data);
      },
      newData() {
        if (!this.activity.data) {
          return 'N/A';
        }
        return this.getCommissionsData(this.activity.data);
      },
      getCommissionsData(data) {
        let returnValue = '';

        data.forEach((commission) => {
          if (!parseFloat(commission.amount_over)) {
            returnValue += this.$i18n.t('Percentage: {percent}', {
              percent: Math.round(commission.percent),
            });
          } else {
            returnValue += this.$i18n.t('Percentage: {percent} | Over: {over}', {
              percent: Math.round(commission.percent),
              over: this.$options.filters.asCurrency(commission.amount_over),
            });
          }
          returnValue += "<br>";
        });

        return returnValue;
      }
    }
  }
</script>

<style scoped>

</style>
